import type { ISectionContactData } from '@services/types';

import { Button } from '@components/Button';
import Card from '@components/Card';
import Icon from '@components/Icon';
import StarRating from '@components/StarRating';

import { useContact } from './hooks';

import style from './styles.module.scss';

const ContactSectionContent = ({ contactData }: { contactData: ISectionContactData }) => {
  const { contact_person } = contactData;
  const { name, email: contactEmail, phone, title } = contact_person;

  const { initials, handleLetsTalk, handleVisitWebsite } = useContact(name);

  return (
    <div className={style.wrapper}>
      <div className="section-header">
        <h3 className="section-subtitle">Campaign Review</h3>
        <h1 className="section-title">CONTACT</h1>
      </div>
      <Card className={style['feedback-card']}>
        <div className={style['card-label']}>YOUR FEEDBACK</div>
        <div className={style['feedback-content']}>
          <div className={style['feedback-column']}>
            <StarRating
              title="How would you rate your overall campaign experience with YOC?"
              subtitle="Tap a star to rate (1 = poor, 5 = excellent)"
              starCount={5}
            />
          </div>
          <div className={style['feedback-column']}>
            <StarRating
              title="How likely are you to recommend YOC to a friend?"
              subtitle="0 = not at all likely &middot; 5 = extremely likely"
              starCount={5}
            />
          </div>
        </div>
      </Card>
      <Card className={style['sales-card']}>
        <div className={style['sales-card-header']}>
          <span className={style['card-label']}>CONTACT SALES</span>
          <span className={style['timezone-label']}>MON-FRI &middot; 09:00-18:00 CET</span>
        </div>
        <div className={style['sales-top']}>
          <h2 className={style['sales-title']}>READY TO START YOUR NEXT CAMPAIGN?</h2>
          <p className={style['sales-subtitle']}>
            Let&apos;s discuss your next AI-powered campaign on VIS.X.
            <br />
            Our team will design a solution tailored to your KPIs.
          </p>
        </div>
        <div className={style.divider} />
        <div className={style['sales-bottom']}>
          <div className={style['profile-row']}>
            <div className={style.avatar}>
              <span>{initials}</span>
            </div>
            <div className={style['profile-info']}>
              <span className={style['profile-role']}>{title || 'Director Sales'}</span>
              <span className={style['profile-name']}>{name}</span>
              <div className={style['contact-info-row']}>
                <a
                  href={`mailto:${contactEmail}`}
                  className={style['contact-link']}
                >
                  <Icon
                    name="envelope"
                    size={18}
                    className={style['contact-icon']}
                  />
                  {contactEmail}
                </a>
                <a
                  href={`tel:${phone}`}
                  className={style['contact-link']}
                >
                  <Icon
                    name="phone"
                    size={18}
                    className={style['contact-icon']}
                  />
                  {phone}
                </a>
              </div>
            </div>
          </div>
          <Button
            className={style['talk-button']}
            onClick={handleLetsTalk}
          >
            Let&apos;s talk
            <Icon
              name="export"
              size={16}
            />
          </Button>
        </div>
      </Card>
      <Card
        className={style['website-card']}
        onClick={handleVisitWebsite}
      >
        <div className={style['card-label']}>VISIT OUR WEBSITE</div>
        <div className={style['website-content']}>
          <span className={style['website-domain']}>yoc.com</span>
          <span className={style['website-tagline']}>The Technology Platform for High-Impact Advertising.</span>
        </div>
      </Card>
    </div>
  );
};

export default ContactSectionContent;
